(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-gallery-product"]) return;
  try {
    
  const GALLERY_LIGHTBOX_SELECTOR = '[data-fancybox="gallery"]';

  function toggleFilters() {
    const filterLi = document.querySelector('li.custom-filter__list__item--facets');

    if (!filterLi) return;

    const filterLiToggle = filterLi.querySelector('a.custom-filter__list__item--facets-toggle');
    if (!filterLiToggle) return;

    const isOpen = sessionStorage.getItem('gallery-facets-open');

    if (isOpen === 'true') {
      filterLi.classList.add('is-open');
    }

    if (filterLiToggle.dataset.listenerAdded === 'true') return;

    filterLiToggle.addEventListener('click', (e) => {
      e.preventDefault();
      filterLi.classList.toggle('is-open');
      sessionStorage.setItem('gallery-facets-open', filterLi.classList.contains('is-open'));
    });

    filterLiToggle.dataset.listenerAdded = 'true';
  }

  function bindGalleryLightbox() {
    if (typeof Fancybox === 'undefined') return;

    const galleryItems = document.querySelectorAll(GALLERY_LIGHTBOX_SELECTOR);
    if (!galleryItems.length) return;

    Fancybox.unbind(GALLERY_LIGHTBOX_SELECTOR);

    Fancybox.bind(GALLERY_LIGHTBOX_SELECTOR, {
      Thumbs: false,
      Toolbar: {
        display: false,
      },
      Images: {
        initialSize: 'fit',
      },
      on: {
        open: () => {
          const productGrid = document.getElementById('product-grid');
          if (productGrid) {
            productGrid.classList.remove('animate--fadeIn--delay');
          }
          
          toggleFilters();
        },
        close: () => {
          toggleFilters();
        },
        destroy: () => {
          toggleFilters();
        },
      },
    });
  }

  function initGalleryLightbox(retries = 20) {
    if (typeof Fancybox === 'undefined') {
      if (retries <= 0) return;
      window.setTimeout(() => initGalleryLightbox(retries - 1), 100);
      return;
    }

    bindGalleryLightbox();
  }

  function initGalleryInteractions() {
    toggleFilters();
    initGalleryLightbox();
  }

  initGalleryInteractions();
  document.addEventListener('gallery:updated', initGalleryInteractions);
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    

  function depositLink() {
      var button = document.getElementById('add-to-cart-button');
      var depositLink = document.querySelector('.price-breakdown__deposit');

      if (button && depositLink) {
        depositLink.addEventListener('click', function (e) {
     
          e.preventDefault();
          var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-subheading-height')) || 0;
          var offset = headerHeight + (window.innerHeight * 0.2);
          var correct = button.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: correct, behavior: 'smooth' });  
        });
      }  
    }
  
  document.addEventListener('DOMContentLoaded', function() { 
    depositLink();
  });

  } catch(e) { console.error(e); }
})();
})();
